module.exports = __webpack_public_path__ + "img/head1green.7dd37450.png";